import React from 'react';
import { getCalendarNow, getDefaultScrollTime, transformEventsForPrimaryTimezone } from '../utils/calendarTimezone.utils';

interface UseCalendarTimezoneParams<T> {
  events: T[];
  showDualGutter: boolean;
  primaryTimezone?: string;
}

export const useCalendarTimezone = <
  T extends {
    start: Date | string;
    end: Date | string;
  }
>({
  events,
  showDualGutter,
  primaryTimezone,
}: UseCalendarTimezoneParams<T>) => {
  const transformedEvents = React.useMemo(
    () =>
      transformEventsForPrimaryTimezone({
        events,
        enabled: showDualGutter,
        primaryTimezone,
      }),
    [events, showDualGutter, primaryTimezone],
  );

  const calendarNow = React.useMemo(
    () =>
      getCalendarNow({
        enabled: showDualGutter,
        primaryTimezone,
      }),
    [showDualGutter, primaryTimezone],
  );

  const scrollToTime = React.useMemo(() => getDefaultScrollTime({ enabled: showDualGutter, primaryTimezone }), [
    showDualGutter,
    primaryTimezone,
  ]);

  return {
    transformedEvents,
    calendarNow,
    scrollToTime,
  };
};
